
/*!
 * @pendo/components 3.25.3
 * (c) 2018-present
 */

import 'lodash/isEqual';
import 'just-kebab-case';
import './labels-mixin.js';
import 'focus-visible/dist/focus-visible.js';
import './_rollupPluginBabelHelpers-mixin.js';
import 'lodash/kebabCase';
import 'feather-icons';
import './pendo-icon.js';
import 'vue';
import get from 'lodash/get';
import './pendo-loading-mixin.js';
import './pendo-loading-indicator.js';
import PendoButton from './pendo-button.js';
import { P as PendoTooltip } from './tooltip-mixin.js';
import 'lodash/isNumber';
import './table-auto-height-mixin.js';
import PendoDrawer from './pendo-drawer.js';

var script = {
  name: 'PendoSidePanelDrawer',
  components: {
    PendoButton,
    PendoDrawer
  },
  directives: {
    PendoTooltip
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: null
    },
    header: {
      type: Object,
      default: () => ({})
    },
    body: {
      type: Object,
      default: () => ({})
    },
    zIndex: {
      type: Number,
      default: 20000
    }
  },

  data() {
    return {
      overflowTooltipContent: this.headerTitleProp
    };
  },

  computed: {
    noComponentClass() {
      return this.header.component ? '' : 'pendo-side-panel-drawer--no-component';
    },

    headerTitleProp() {
      return get(this.header, 'props.title', '');
    }

  },
  methods: {
    checkForOverflowingContent(event, tooltipText) {
      const _event$target = event.target,
            scrollWidth = _event$target.scrollWidth,
            clientWidth = _event$target.clientWidth;
      this.overflowTooltipContent = scrollWidth > clientWidth ? tooltipText : null;
    }

  }
};

const __vue_script__ = script;

var __vue_render__ = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('pendo-drawer', {
    attrs: {
      "visible": _vm.visible,
      "class-name": [_vm.className, 'pendo-side-panel-drawer', _vm.noComponentClass],
      "push": "body",
      "size": "372px",
      "placement": "right",
      "z-index": _vm.zIndex
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('close');
      }
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function (ref) {
        var close = ref.close;
        return [_vm.header.component ? _c(_vm.header.component, _vm._b({
          tag: "component",
          on: {
            "close": close
          }
        }, 'component', _vm.header.props, false)) : _vm._e(), _vm._v(" "), !_vm.header.component ? [_c('h3', {
          directives: [{
            name: "pendo-tooltip",
            rawName: "v-pendo-tooltip",
            value: {
              content: _vm.overflowTooltipContent,
              classes: 'pendo-side-panel-drawer__title-tooltip',
              delay: {
                show: 300,
                hide: 0
              },
              arrow: true,
              multiline: true,
              boundariesElement: 'body'
            },
            expression: "{\n                    content: overflowTooltipContent,\n                    classes: 'pendo-side-panel-drawer__title-tooltip',\n                    delay: { show: 300, hide: 0 },\n                    arrow: true,\n                    multiline: true,\n                    boundariesElement: 'body',\n                }"
          }],
          staticClass: "pendo-side-panel-drawer__title",
          on: {
            "mouseenter": function ($event) {
              return _vm.checkForOverflowingContent($event, _vm.headerTitleProp);
            }
          }
        }, [_vm._v("\n                " + _vm._s(_vm.headerTitleProp) + "\n            ")]), _vm._v(" "), _c('div', {
          staticClass: "pendo-drawer__close"
        }, [_c('pendo-button', {
          attrs: {
            "theme": "app",
            "type": "tertiary",
            "icon": "x",
            "icon-size": "20"
          },
          on: {
            "click": close
          }
        })], 1)] : _vm._e()];
      }
    }, {
      key: "body",
      fn: function () {
        return [_c(_vm.body.component, _vm._g(_vm._b({
          tag: "component",
          on: {
            "close": function ($event) {
              return _vm.$emit('close');
            }
          }
        }, 'component', _vm.body.props, false), _vm.$listeners))];
      },
      proxy: true
    }])
  });
};

var __vue_staticRenderFns__ = [];
const __vue_inject_styles__ = undefined;
const __vue_scope_id__ = undefined;
const __vue_is_functional_template__ = false;

function __vue_normalize__(template, style, script, scope, functional, moduleIdentifier, createInjector, createInjectorSSR) {
  const component = (typeof script === 'function' ? script.options : script) || {};
  component.__file = "pendo-side-panel-drawer.vue";

  if (!component.render) {
    component.render = template.render;
    component.staticRenderFns = template.staticRenderFns;
    component._compiled = true;
    if (functional) component.functional = true;
  }

  component._scopeId = scope;

  return component;
}

var pendoSidePanelDrawer = __vue_normalize__({
  render: __vue_render__,
  staticRenderFns: __vue_staticRenderFns__
}, __vue_inject_styles__, __vue_script__, __vue_scope_id__, __vue_is_functional_template__);

export default pendoSidePanelDrawer;
